module.exports = __webpack_public_path__ + "static/img/homeright21.dc16efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeright21.png
// module id = UiU/
// module chunks = 13